import type {PipelineSettings} from '../types'

type BaseVcsRootDto = {
  url: string
  branch: string
  vcsName: string
  branchSpecification?: string
  username?: string
}

type NewVcsRootDto = BaseVcsRootDto & {
  isPrivate?: boolean
  connectionId?: string
}

type VcsRootDto = BaseVcsRootDto & {
  id: string
}

type NewTriggerDto = {
  type: string
  parameters?: Record<string, string>
  disabled?: boolean
}

type TriggerDto = Required<NewTriggerDto>

export type NewIntegrationDto = {
  id?: string
  type: string
  parameters: Record<string, string>
}

type IntegrationDto = Required<NewIntegrationDto>

export type NewPipelineDto = {
  yaml: string
  vcsRoot: NewVcsRootDto
  triggers?: NewTriggerDto[]
  integrations?: NewIntegrationDto[]
}

export type NewPipeline = Omit<NewPipelineDto, 'yaml'> & {
  settings: PipelineSettings
}

export type PipelineDto = {
  id: string
  pipelineVersion?: string
  yaml: string
  vcsRoot: VcsRootDto
  triggers: TriggerDto[]
  integrations: IntegrationDto[]
}

export type Pipeline = Omit<PipelineDto, 'yaml'> & {
  settings: PipelineSettings
}

export type UpdatePipelineArg = {
  id: string
  body: NewPipeline
}

type Owner = {
  avatarUrl: string
  login: string
}

type Repository = {
  defaultBranch: string
  htmlUrl: string
  name: string
  private: boolean
}

export enum RepositoryGroupType {
  CURRENT_USER = 1,
  OTHER_USER = 2,
  ORGANISATION = 3,
}

export type RepositoryGroup = {
  myGroupType: RepositoryGroupType
  myOwner: Owner
  myRepositories: Repository[]
}
